import { NavigationCombined } from './type';

export const lng = (internal: boolean, urlPrefix = ''): NavigationCombined => {
  return {
    order: 1,
    app: 'lng',
    label: 'LNG',
    icon: 'schema',
    flat: false,
    prefix: 'lng',
    title: 'LNG',
    children: [
      {
        label: 'Capture',
        link: !internal ? `${urlPrefix}/g/lng/capture` : null,
        route: internal ? ['/', 'lng', 'capture'] : null,
        icon: 'insert_drive_file',
      },
      {
        label: 'Alerts',
        route: internal ? ['/', 'lng', 'alerts'] : null,
        link: !internal ? `${urlPrefix}/g/lng/alerts` : null,
        icon: 'add_alert',
        disabled: false,
      },
    ],
  };
};
